<template>
  <div>
      <div class="search_header">
        <div>
            <div class="search_fn" @click='toSearch'>
                <i class='icon1'></i>
                <div class="search-item">
                  <form action="javascript:;">
                    <!-- <input type="search" placeholder="请输入关键字" disabled> -->
                    <!-- 2024-04-29修改，搜索框不能点击问题 -->
                    <input type="search" placeholder="请输入关键字">
                  </form>
                </div>
            </div>
            <span @click.stop='toSelf'>
              <img src="@/assets/imgs/self.png" alt="">
            </span>
        </div>
    </div>
      <div class="container">
        <div id="banner">
          <mt-swipe class="swipe" :style="{height:swipeHeight+'px'}" :auto="4000" >
            <mt-swipe-item v-for="(item,index) of this.$store.state.imgList" :key="index">
              <!-- <a :href="jump(item.url)"> -->
                <div @click="jump(item.url)">
                    <img class="img" :src="item.image" alt="">
                </div>
              <!-- </a> -->
            </mt-swipe-item>
          </mt-swipe>
        </div>
        <div class="pageView">
          <div class="pageViewLeft">
            <input  readonly="readonly" class="input">
            <span class="text2">平台访问人数</span> 
            <span class="blueColor text3">{{$store.state.pageview}}</span>
          </div>
          <router-link to="/baobiao" class="baobiao">
            <img src="../assets/baobiaozhongxin.png" alt="">
            <span class="blueColor">详细报表</span> 
          </router-link>
        </div>
        <div class='pitem' v-for="(item,index) of  this.$store.state.ziyuanList" :key="index">
          <div class='title' @click.stop='toggleFn(index)'>
              <span>{{item.name}}</span>
              <img :src="item.isCheck?icon1:icon2" alt="">
          </div>
          <div class="content" >
              <!-- 二级目录，内套三级目录 -->
              <homelist v-show='item.isCheck' :cur='index' :title="item.name" :childrenList="item.children" @updateToggle='toggleChildren'></homelist>
              <!-- 三级目录（这里数据库同二级目录平级） -->
              <!-- <itemlist v-if="index!=0" :itemlist="item.children"></itemlist> -->
          </div>
        </div>
      </div>
      <beian></beian>
  </div>
</template>

<script>
import https from '../https.js' 　
 import wx from 'weixin-js-sdk'
import homelist from "./common/homelist"
import itemlist from "./common/itemlist"
import beian from "./common/footer"
export default {
  data () {
    return {
      swipeHeight:"",
      icon1:require('@/assets/imgs/up.png'),
      icon2:require('@/assets/imgs/down.png'),
    }
  },
  components:{
    "homelist":homelist,
    "itemlist":itemlist,
    "beian":beian,
  },
  created(){
    document.title=this.$store.state.title1;
    this.wxshareArtwork();
    this.$store.state.totleIsShow=false;
    //动态获取设置banner宽高
     var cellWidth=document.body.clientWidth;
     var width=cellWidth-24;    //24左右内边距
     this.swipeHeight=Math.floor( width/2);

      
      sessionStorage.clear("lToD");       //首页清除二级页面记录的lToD

      if(this.$store.state.ziyuanList!=""){  //如果首页数据请求过，有，则不再请求数据
        return
      }else{
        this.$store.commit('getMsg')
      }
  },
  mounted(){
  },
  updated(){
     
  },
  methods:{
    toggleFn(cur){
      this.$store.state.ziyuanList[cur].isCheck=!this.$store.state.ziyuanList[cur].isCheck
    },
    toggleChildren(cur,childCur){
      this.$store.state.ziyuanList[cur].children[childCur].isCheck=!this.$store.state.ziyuanList[cur].children[childCur].isCheck
    },
    toSearch(){
      this.$router.push({name:'search'})
    },
    toSelf(){
      this.$router.push({name:'selfinfo'})
    },
     //微信分享
      wxshareArtwork(){
                var that=this;
                var url=new Object();
                url.url=window.location.href.split('#')[0];
                 https.fetchPost("login/wxShare",url)
                  .then(res=>{
                        var data=res.data.data;
                        var appId=data.appid;
                        var timestamp=data.timestamp;
                        var nonceStr=data.noncestr;
                        var signature=data.signature;
                        wx.config({
                            debug: false,
                            appId: data.appid,
                            timestamp: data.timestamp,
                            nonceStr: data.noncestr,
                            signature: data.signature,
                            jsApiList: [
                                'onMenuShareTimeline',
                                'onMenuShareAppMessage'
                            ]
                        });
                        wx.ready( function() {
                            var title=that.$store.state.title1;
                            var link=window.location.href.split('#')[0]+'#/';
                            var imgUrl="https://book-new.oss-cn-beijing.aliyuncs.com/static/share_def.png";  //分享默认图片
                            var desc="";     //描述信息
                            wx.onMenuShareTimeline({//朋友圈
                                title: title, // 分享标题
                                link: link, // 分享链接
                                imgUrl: imgUrl, // 分享图标
                                success: function () {
                                    
                                },
                                cancel: function () {
                                    
                                }
                            });
                            wx.onMenuShareAppMessage({//好友
                                title: title, // 分享标题
                                desc:desc, //
                                link: link, // 分享链接
                                imgUrl: imgUrl, // 分享图标
                                type: '', // 分享类型,music、video或link，不填默认为link
                                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                                success: function () {},
                                cancel: function () {}
                            });
                        })
                  });  
            },

    jump(url){
        if(url.indexOf("http")==-1){
          this.$router.push(url)
        }else{
          window.location.href=url;
        }
    }
  }
}
</script>
<style src="@/assets/search.css" scoped></style>
<style scoped>
  .jishu{
    text-align:center;
    padding:0px 0 30px 0;
    margin-top:-10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .jishu a{
      text-decoration:none;
      color:#999;
      font-size:12px;
      -webkit-tap-highlight-color:transparent;
  }
  .container{
    padding:0 12px 12px 12px;
    margin-top:58px;
  }
  .swipe{
    border-radius:10px;
  }
   mt-swipe-item{
     position:relative;
  }
  .text1{
    font-size:16px;
    height:45px;
    line-height: 45px;
    color: #000;
  }
  .pitem{
    box-shadow: 0px 0.5px 4px 0px rgba(0,0,0,0.06); 
     margin-bottom: 12px;
  }
  .title{
    font-size:15px;
    /* margin-top:28px; */
   
    color:#333;
    height:55px;
    box-sizing: border-box;
    padding:0 13px;
    font-weight: 700;
    display:flex;
    justify-content: space-between;
    align-items: center;
  }
    .title img{
      width:14px;
    }
  .pageView{
    height:45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    background-color: #fff;
    margin:14px 0;
    background:rgba(255,255,255,1);
    box-shadow:0px 4px 7px 0px rgba(9,91,84,0.04);
    border-radius:5px;
  }
  .pageViewLeft{
    height:45px;
    line-height: 45px;
  }
  .text2{
     font-size:15px;
     margin-right:8px;
     margin-left:4px;
  }
  .baobiao{
    border:1px solid #00878b;
    height:25px;
    line-height: 25px;
    /* width:71px; */
    padding: 0 5px;
    border-radius:4px;
    margin-right:8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-decoration: none;
  }
  .baobiao>img{
    width:13px;
    height:13px;
    margin-right:4.5px;
  }
  .baobiao>.blueColor{
    font-size:11px;
  }
  .blueColor{
    color:#00878b;
  }
  .img{
    width: 100%;
    height:100%;
  }
  .input{
    background: -webkit-linear-gradient(120deg,#00878b, #95FEF5); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(120deg,#00878b, #95FEF5); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(120deg,#00878b, #95FEF5); /* Firefox 3.6 - 15 */
    background: linear-gradient(120deg,#00878b, #95fef5); /* 标准的语法 */
    /* background: -webkit-linear-gradient(120deg,#5ED8CE, #95FEF5); Safari 5.1 - 6.0 
    background: -o-linear-gradient(120deg,#5ED8CE, #95FEF5); Opera 11.1 - 12.0 
    background: -moz-linear-gradient(120deg,#5ED8CE, #95FEF5);  Firefox 3.6 - 15 
    background: linear-gradient(120deg,#5ed8ce, #95fef5);  标准的语法 */
    border:0;
    border-radius:5px;
    width:5px;
    height:45px;
  }
  .content{
        padding: 0 10px;
        border-radius:5px;
        background: #fff;
  }
  .container /deep/ .mint-swipe-indicators{
    bottom: 6%;
  }
   .container /deep/ .mint-swipe-indicator{
    background:rgba(222,222,222,1);
    width:6px; 
    height:6px;
    opacity: 1;
  }
  .container /deep/ .mint-swipe-indicator.is-active{
    background:#00878b;
    width:15px; 
    height:6px;
    border-radius:3px;
    opacity: 1;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/home.vue